'use client'

import { useEffect, useRef } from 'react'
import { useSession } from 'next-auth/react'
import { useStatsigClient } from '@statsig/react-bindings'

export function StatsigAuthBridge({ tenantId }: { tenantId: string }) {
    const { client } = useStatsigClient()
    const { data: session, status }: any = useSession()

    // Keep track of the last userID we sent to Statsig
    const lastUserID = useRef<string | null>(null)

    useEffect(() => {
        if (!client) return
        if (status !== 'authenticated' && status !== 'unauthenticated') return

        const prefetchData = async () => {
            const userId = session?.userId as any

            // Only update if the user ID changed
            if (lastUserID.current === userId) return

            const { stableID } = client.getContext()

            const newUser = {
                userID: userId ?? '',
                email: session?.user?.email ?? '',
                custom: {
                    tenant: tenantId ?? 'unknown',
                    role: session?.role ?? '',
                },
                customIDs: { stableID: stableID ?? '' }, // keep the same device-level ID
            }

            await client.dataAdapter.prefetchData(newUser);
            client.updateUserAsync(newUser);

            // Move stableID into cookie.
            navigator.sendBeacon(`/api/statsig/init`, JSON.stringify({
                stableID: stableID,
            }))

            lastUserID.current = userId
        }

        prefetchData()
    }, [client, session, status, tenantId])

    return null
}
